



















import { Component, Prop, Vue } from 'vue-property-decorator';
import _ from 'lodash';
import ProcessedRecordModel from '@/models/ProcessedRecordModel';
import dayjs from 'dayjs';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

import Api from '@/store/surelockApi';
import {
  BAlert,
  BButton,
  BCard,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BOverlay,
  BSpinner,
} from 'bootstrap-vue';

@Component({
  components: {
    FontAwesomeIcon,
    BAlert,
    BButton,
    BCard,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BOverlay,
    BSpinner,
  },
})
export default class ProcessedVideos extends Vue {
  @Prop() preservation!: any;

  processedRecords = new Array<ProcessedRecordModel>();

  videosDataIsReady = false;
  
  processedRecordFields = [
    {
      name: 'Filename',
      prop: 's3FileName',
    },
    {
      name: 'UUID',
      prop: 'uuid',
    },
    {
      name: 'Duration',
      prop: 'duration',
    },
    {
      name: 'Created',
      prop: 'created',
    }
  ];

  async mounted(): Promise<void> {
    await this.loadProcessedRecords();

    if (!this.isEmpty()) {
      for (let record of this.processedRecords) {
        record.created = dayjs(record.created).format('MMM-DD-YYYY HH:mm');
        if (record.deleted) {
          record.deleted = dayjs(record.deleted).format('MMM-DD-YYYY HH:mm');
        }
      }
    }
  }

  async loadProcessedRecords(): Promise<void> {
    try {
      const data = await Api.getProcessedRecords(this.preservation.id);
      this.processedRecords = data.preservations;
      this.videosDataIsReady = true;
    } catch (err) {
      const message = _.get(err, 'response.data.message') || 'Error loading Processed Records';
      this.$toasted.error(message, { duration: 3000 });
      return;
    }
  }

  // Helper
  getValueForProcessedRecord(preservation: ProcessedRecordModel, value: string): any {
    return _.get(preservation, value) || 'N/A';
  }

  isEmpty(): boolean {
    return this.preservation.videosInTimespan === 0;
  }
}
